// AUTO-GENERATED da scripts/set-build-info.js al momento del build — NON modificare a mano.
export const BUILD_DATE = "2026-11-03T15:32:44.506Z";
